export enum EmployeeSurveyStatus {
    Unknown = 0,
    Started = 1,
    Finished = 2
}